import { FormControl } from "@angular/forms";
import { TipoStatusNotificacaoEnum } from "../enums/tipo-status-notificacao-enum";
import { MarcacaoConsulta } from "../marcacao/marcacao-consulta/marcacao-consulta";
import { ChaveValorBooleanInterface } from "./chave-valor-boolean-interface";
import { ChaveValorNumberInterface } from "./chave-valor-number-interface";
import { ChaveValorStrInterface } from "./chave-valor-str-interface";
import { Horario } from "./hora-atendimeno";
import { UF } from "./uf";

export class Util {

    public static SEPARADOR: string = ';;;';

    public static tituloEmpresaSms: string = 'COPE: ';

    public static tamanhoMaximoMensagemSms: number = 160;

    public static getTamanhaMaximoMensagemSmsSemTitulo(): number {

        return this.tamanhoMaximoMensagemSms - this.tituloEmpresaSms.length;
    }

    public static listaUFs: UF[] = [
        { sigla: 'AC', nome: 'Acre' },
        { sigla: 'AL', nome: 'Alagoas' },
        { sigla: 'AP', nome: 'Amapá' },
        { sigla: 'AM', nome: 'Amazonas' },
        { sigla: 'BA', nome: 'Bahia' },
        { sigla: 'CE', nome: 'Ceará' },
        { sigla: 'DF', nome: 'Distrito Federal' },
        { sigla: 'ES', nome: 'Espírito Santo' },
        { sigla: 'GO', nome: 'Goiás' },
        { sigla: 'MA', nome: 'Maranhão' },
        { sigla: 'MT', nome: 'Mato Grosso' },
        { sigla: 'MS', nome: 'Mato Grosso do Sul' },
        { sigla: 'MG', nome: 'Minas Gerais' },
        { sigla: 'PA', nome: 'Pará' },
        { sigla: 'PB', nome: 'Paraíba' },
        { sigla: 'PR', nome: 'Paraná' },
        { sigla: 'PE', nome: 'Pernambuco' },
        { sigla: 'PI', nome: 'Piauí' },
        { sigla: 'RJ', nome: 'Rio de Janeiro' },
        { sigla: 'RN', nome: 'Rio Grande do Norte' },
        { sigla: 'RS', nome: 'Rio Grande do Sul' },
        { sigla: 'RO', nome: 'Rondônia' },
        { sigla: 'RR', nome: 'Roraima' },
        { sigla: 'SC', nome: 'Santa Catarina' },
        { sigla: 'SP', nome: 'São Paulo' },
        { sigla: 'SE', nome: 'Sergipe' },
        { sigla: 'TO', nome: 'Tocantins' },
    ];

    public static listaHorasAtendimentos: Horario[] = [
        { codigo: 0, descricao: '00:00' },
        { codigo: 5, descricao: '00:05' },
        { codigo: 10, descricao: '00:10' },
        { codigo: 15, descricao: '00:15' },
        { codigo: 20, descricao: '00:20' },
        { codigo: 25, descricao: '00:25' },
        { codigo: 30, descricao: '00:30' },
        { codigo: 35, descricao: '00:35' },
        { codigo: 40, descricao: '00:40' },
        { codigo: 45, descricao: '00:45' },
        { codigo: 50, descricao: '00:50' },
        { codigo: 55, descricao: '00:55' },

        { codigo: 100, descricao: '01:00' },
        { codigo: 105, descricao: '01:05' },
        { codigo: 110, descricao: '01:10' },
        { codigo: 115, descricao: '01:15' },
        { codigo: 120, descricao: '01:20' },
        { codigo: 125, descricao: '01:25' },
        { codigo: 130, descricao: '01:30' },
        { codigo: 135, descricao: '01:35' },
        { codigo: 140, descricao: '01:40' },
        { codigo: 145, descricao: '01:45' },
        { codigo: 150, descricao: '01:50' },
        { codigo: 155, descricao: '01:55' },

        { codigo: 200, descricao: '02:00' },
        { codigo: 205, descricao: '02:05' },
        { codigo: 210, descricao: '02:10' },
        { codigo: 215, descricao: '02:15' },
        { codigo: 220, descricao: '02:20' },
        { codigo: 225, descricao: '02:25' },
        { codigo: 230, descricao: '02:30' },
        { codigo: 235, descricao: '02:35' },
        { codigo: 240, descricao: '02:40' },
        { codigo: 245, descricao: '02:45' },
        { codigo: 250, descricao: '02:50' },
        { codigo: 255, descricao: '02:55' },

        { codigo: 300, descricao: '03:00' },
        { codigo: 305, descricao: '03:05' },
        { codigo: 310, descricao: '03:10' },
        { codigo: 315, descricao: '03:15' },
        { codigo: 320, descricao: '03:20' },
        { codigo: 325, descricao: '03:25' },
        { codigo: 330, descricao: '03:30' },
        { codigo: 335, descricao: '03:35' },
        { codigo: 340, descricao: '03:40' },
        { codigo: 345, descricao: '03:45' },
        { codigo: 350, descricao: '03:50' },
        { codigo: 355, descricao: '03:55' },

        { codigo: 400, descricao: '04:00' },
        { codigo: 405, descricao: '04:05' },
        { codigo: 410, descricao: '04:10' },
        { codigo: 415, descricao: '04:15' },
        { codigo: 420, descricao: '04:20' },
        { codigo: 425, descricao: '04:25' },
        { codigo: 430, descricao: '04:30' },
        { codigo: 435, descricao: '04:35' },
        { codigo: 440, descricao: '04:40' },
        { codigo: 445, descricao: '04:45' },
        { codigo: 450, descricao: '04:50' },
        { codigo: 455, descricao: '04:55' },

        { codigo: 500, descricao: '05:00' },
        { codigo: 505, descricao: '05:05' },
        { codigo: 510, descricao: '05:10' },
        { codigo: 515, descricao: '05:15' },
        { codigo: 520, descricao: '05:20' },
        { codigo: 525, descricao: '05:25' },
        { codigo: 530, descricao: '05:30' },
        { codigo: 535, descricao: '05:35' },
        { codigo: 540, descricao: '05:40' },
        { codigo: 545, descricao: '05:45' },
        { codigo: 550, descricao: '05:50' },
        { codigo: 555, descricao: '05:55' },

        { codigo: 600, descricao: '06:00' },
        { codigo: 605, descricao: '06:05' },
        { codigo: 610, descricao: '06:10' },
        { codigo: 615, descricao: '06:15' },
        { codigo: 620, descricao: '06:20' },
        { codigo: 625, descricao: '06:25' },
        { codigo: 630, descricao: '06:30' },
        { codigo: 635, descricao: '06:35' },
        { codigo: 640, descricao: '06:40' },
        { codigo: 645, descricao: '06:45' },
        { codigo: 650, descricao: '06:50' },
        { codigo: 655, descricao: '06:55' },

        { codigo: 700, descricao: '07:00' },
        { codigo: 705, descricao: '07:05' },
        { codigo: 710, descricao: '07:10' },
        { codigo: 715, descricao: '07:15' },
        { codigo: 720, descricao: '07:20' },
        { codigo: 725, descricao: '07:25' },
        { codigo: 730, descricao: '07:30' },
        { codigo: 735, descricao: '07:35' },
        { codigo: 740, descricao: '07:40' },
        { codigo: 745, descricao: '07:45' },
        { codigo: 750, descricao: '07:50' },
        { codigo: 755, descricao: '07:55' },

        { codigo: 800, descricao: '08:00' },
        { codigo: 805, descricao: '08:05' },
        { codigo: 810, descricao: '08:10' },
        { codigo: 815, descricao: '08:15' },
        { codigo: 820, descricao: '08:20' },
        { codigo: 825, descricao: '08:25' },
        { codigo: 830, descricao: '08:30' },
        { codigo: 835, descricao: '08:35' },
        { codigo: 840, descricao: '08:40' },
        { codigo: 845, descricao: '08:45' },
        { codigo: 850, descricao: '08:50' },
        { codigo: 855, descricao: '08:55' },

        { codigo: 900, descricao: '09:00' },
        { codigo: 905, descricao: '09:05' },
        { codigo: 910, descricao: '09:10' },
        { codigo: 915, descricao: '09:15' },
        { codigo: 920, descricao: '09:20' },
        { codigo: 925, descricao: '09:25' },
        { codigo: 930, descricao: '09:30' },
        { codigo: 935, descricao: '09:35' },
        { codigo: 940, descricao: '09:40' },
        { codigo: 945, descricao: '09:45' },
        { codigo: 950, descricao: '09:50' },
        { codigo: 955, descricao: '09:55' },

        { codigo: 1000, descricao: '10:00' },
        { codigo: 1005, descricao: '10:05' },
        { codigo: 1010, descricao: '10:10' },
        { codigo: 1015, descricao: '10:15' },
        { codigo: 1020, descricao: '10:20' },
        { codigo: 1025, descricao: '10:25' },
        { codigo: 1030, descricao: '10:30' },
        { codigo: 1035, descricao: '10:35' },
        { codigo: 1040, descricao: '10:40' },
        { codigo: 1045, descricao: '10:45' },
        { codigo: 1050, descricao: '10:50' },
        { codigo: 1055, descricao: '10:55' },

        { codigo: 1100, descricao: '11:00' },
        { codigo: 1105, descricao: '11:05' },
        { codigo: 1110, descricao: '11:10' },
        { codigo: 1115, descricao: '11:15' },
        { codigo: 1120, descricao: '11:20' },
        { codigo: 1125, descricao: '11:25' },
        { codigo: 1130, descricao: '11:30' },
        { codigo: 1135, descricao: '11:35' },
        { codigo: 1140, descricao: '11:40' },
        { codigo: 1145, descricao: '11:45' },
        { codigo: 1150, descricao: '11:50' },
        { codigo: 1155, descricao: '11:55' },

        { codigo: 1200, descricao: '12:00' },
        { codigo: 1205, descricao: '12:05' },
        { codigo: 1210, descricao: '12:10' },
        { codigo: 1215, descricao: '12:15' },
        { codigo: 1220, descricao: '12:20' },
        { codigo: 1225, descricao: '12:25' },
        { codigo: 1230, descricao: '12:30' },
        { codigo: 1235, descricao: '12:35' },
        { codigo: 1240, descricao: '12:40' },
        { codigo: 1245, descricao: '12:45' },
        { codigo: 1250, descricao: '12:50' },
        { codigo: 1255, descricao: '12:55' },

        { codigo: 1300, descricao: '13:00' },
        { codigo: 1305, descricao: '13:05' },
        { codigo: 1310, descricao: '13:10' },
        { codigo: 1315, descricao: '13:15' },
        { codigo: 1320, descricao: '13:20' },
        { codigo: 1325, descricao: '13:25' },
        { codigo: 1330, descricao: '13:30' },
        { codigo: 1335, descricao: '13:35' },
        { codigo: 1340, descricao: '13:40' },
        { codigo: 1345, descricao: '13:45' },
        { codigo: 1350, descricao: '13:50' },
        { codigo: 1355, descricao: '13:55' },

        { codigo: 1400, descricao: '14:00' },
        { codigo: 1405, descricao: '14:05' },
        { codigo: 1410, descricao: '14:10' },
        { codigo: 1415, descricao: '14:15' },
        { codigo: 1420, descricao: '14:20' },
        { codigo: 1425, descricao: '14:25' },
        { codigo: 1430, descricao: '14:30' },
        { codigo: 1435, descricao: '14:35' },
        { codigo: 1440, descricao: '14:40' },
        { codigo: 1445, descricao: '14:45' },
        { codigo: 1450, descricao: '14:50' },
        { codigo: 1455, descricao: '14:55' },

        { codigo: 1500, descricao: '15:00' },
        { codigo: 1505, descricao: '15:05' },
        { codigo: 1510, descricao: '15:10' },
        { codigo: 1515, descricao: '15:15' },
        { codigo: 1520, descricao: '15:20' },
        { codigo: 1525, descricao: '15:25' },
        { codigo: 1530, descricao: '15:30' },
        { codigo: 1535, descricao: '15:35' },
        { codigo: 1540, descricao: '15:40' },
        { codigo: 1545, descricao: '15:45' },
        { codigo: 1550, descricao: '15:50' },
        { codigo: 1555, descricao: '15:55' },

        { codigo: 1600, descricao: '16:00' },
        { codigo: 1605, descricao: '16:05' },
        { codigo: 1610, descricao: '16:10' },
        { codigo: 1615, descricao: '16:15' },
        { codigo: 1620, descricao: '16:20' },
        { codigo: 1625, descricao: '16:25' },
        { codigo: 1630, descricao: '16:30' },
        { codigo: 1635, descricao: '16:35' },
        { codigo: 1640, descricao: '16:40' },
        { codigo: 1645, descricao: '16:45' },
        { codigo: 1650, descricao: '16:50' },
        { codigo: 1655, descricao: '16:55' },

        { codigo: 1700, descricao: '17:00' },
        { codigo: 1705, descricao: '17:05' },
        { codigo: 1710, descricao: '17:10' },
        { codigo: 1715, descricao: '17:15' },
        { codigo: 1720, descricao: '17:20' },
        { codigo: 1725, descricao: '17:25' },
        { codigo: 1730, descricao: '17:30' },
        { codigo: 1735, descricao: '17:35' },
        { codigo: 1740, descricao: '17:40' },
        { codigo: 1745, descricao: '17:45' },
        { codigo: 1750, descricao: '17:50' },
        { codigo: 1755, descricao: '17:55' },

        { codigo: 1800, descricao: '18:00' },
        { codigo: 1805, descricao: '18:05' },
        { codigo: 1810, descricao: '18:10' },
        { codigo: 1815, descricao: '18:15' },
        { codigo: 1820, descricao: '18:20' },
        { codigo: 1825, descricao: '18:25' },
        { codigo: 1830, descricao: '18:30' },
        { codigo: 1835, descricao: '18:35' },
        { codigo: 1840, descricao: '18:40' },
        { codigo: 1845, descricao: '18:45' },
        { codigo: 1850, descricao: '18:50' },
        { codigo: 1855, descricao: '18:55' },

        { codigo: 1900, descricao: '19:00' },
        { codigo: 1905, descricao: '19:05' },
        { codigo: 1910, descricao: '19:10' },
        { codigo: 1915, descricao: '19:15' },
        { codigo: 1920, descricao: '19:20' },
        { codigo: 1925, descricao: '19:25' },
        { codigo: 1930, descricao: '19:30' },
        { codigo: 1935, descricao: '19:35' },
        { codigo: 1940, descricao: '19:40' },
        { codigo: 1945, descricao: '19:45' },
        { codigo: 1950, descricao: '19:50' },
        { codigo: 1955, descricao: '19:55' },

        { codigo: 2000, descricao: '20:00' },
        { codigo: 2005, descricao: '20:05' },
        { codigo: 2010, descricao: '20:10' },
        { codigo: 2015, descricao: '20:15' },
        { codigo: 2020, descricao: '20:20' },
        { codigo: 2025, descricao: '20:25' },
        { codigo: 2030, descricao: '20:30' },
        { codigo: 2035, descricao: '20:35' },
        { codigo: 2040, descricao: '20:40' },
        { codigo: 2045, descricao: '20:45' },
        { codigo: 2050, descricao: '20:50' },
        { codigo: 2055, descricao: '20:55' },

        { codigo: 2100, descricao: '21:00' },
        { codigo: 2105, descricao: '21:05' },
        { codigo: 2110, descricao: '21:10' },
        { codigo: 2115, descricao: '21:15' },
        { codigo: 2120, descricao: '21:20' },
        { codigo: 2125, descricao: '21:25' },
        { codigo: 2130, descricao: '21:30' },
        { codigo: 2135, descricao: '21:35' },
        { codigo: 2140, descricao: '21:40' },
        { codigo: 2145, descricao: '21:45' },
        { codigo: 2150, descricao: '21:50' },
        { codigo: 2155, descricao: '21:55' },

        { codigo: 2200, descricao: '22:00' },
        { codigo: 2205, descricao: '22:05' },
        { codigo: 2210, descricao: '22:10' },
        { codigo: 2215, descricao: '22:15' },
        { codigo: 2220, descricao: '22:20' },
        { codigo: 2225, descricao: '22:25' },
        { codigo: 2230, descricao: '22:30' },
        { codigo: 2235, descricao: '22:35' },
        { codigo: 2240, descricao: '22:40' },
        { codigo: 2245, descricao: '22:45' },
        { codigo: 2250, descricao: '22:50' },
        { codigo: 2255, descricao: '22:55' },

        { codigo: 2300, descricao: '23:00' },
        { codigo: 2305, descricao: '23:05' },
        { codigo: 2310, descricao: '23:10' },
        { codigo: 2315, descricao: '23:15' },
        { codigo: 2320, descricao: '23:20' },
        { codigo: 2325, descricao: '23:25' },
        { codigo: 2330, descricao: '23:30' },
        { codigo: 2335, descricao: '23:35' },
        { codigo: 2340, descricao: '23:40' },
        { codigo: 2345, descricao: '23:45' },
        { codigo: 2350, descricao: '23:50' },
        { codigo: 2355, descricao: '23:55' },
    ];

    public static listaHorasAtendimentosSimples: Horario[] = [
        { codigo: 600, descricao: '06:00' },
        { codigo: 605, descricao: '06:05' },
        { codigo: 610, descricao: '06:10' },
        { codigo: 615, descricao: '06:15' },
        { codigo: 620, descricao: '06:20' },
        { codigo: 625, descricao: '06:25' },
        { codigo: 630, descricao: '06:30' },
        { codigo: 635, descricao: '06:35' },
        { codigo: 640, descricao: '06:40' },
        { codigo: 645, descricao: '06:45' },
        { codigo: 650, descricao: '06:50' },
        { codigo: 655, descricao: '06:55' },

        { codigo: 700, descricao: '07:00' },
        { codigo: 705, descricao: '07:05' },
        { codigo: 710, descricao: '07:10' },
        { codigo: 715, descricao: '07:15' },
        { codigo: 720, descricao: '07:20' },
        { codigo: 725, descricao: '07:25' },
        { codigo: 730, descricao: '07:30' },
        { codigo: 735, descricao: '07:35' },
        { codigo: 740, descricao: '07:40' },
        { codigo: 745, descricao: '07:45' },
        { codigo: 750, descricao: '07:50' },
        { codigo: 755, descricao: '07:55' },

        { codigo: 800, descricao: '08:00' },
        { codigo: 805, descricao: '08:05' },
        { codigo: 810, descricao: '08:10' },
        { codigo: 815, descricao: '08:15' },
        { codigo: 820, descricao: '08:20' },
        { codigo: 825, descricao: '08:25' },
        { codigo: 830, descricao: '08:30' },
        { codigo: 835, descricao: '08:35' },
        { codigo: 840, descricao: '08:40' },
        { codigo: 845, descricao: '08:45' },
        { codigo: 850, descricao: '08:50' },
        { codigo: 855, descricao: '08:55' },

        { codigo: 900, descricao: '09:00' },
        { codigo: 905, descricao: '09:05' },
        { codigo: 910, descricao: '09:10' },
        { codigo: 915, descricao: '09:15' },
        { codigo: 920, descricao: '09:20' },
        { codigo: 925, descricao: '09:25' },
        { codigo: 930, descricao: '09:30' },
        { codigo: 935, descricao: '09:35' },
        { codigo: 940, descricao: '09:40' },
        { codigo: 945, descricao: '09:45' },
        { codigo: 950, descricao: '09:50' },
        { codigo: 955, descricao: '09:55' },

        { codigo: 1000, descricao: '10:00' },
        { codigo: 1005, descricao: '10:05' },
        { codigo: 1010, descricao: '10:10' },
        { codigo: 1015, descricao: '10:15' },
        { codigo: 1020, descricao: '10:20' },
        { codigo: 1025, descricao: '10:25' },
        { codigo: 1030, descricao: '10:30' },
        { codigo: 1035, descricao: '10:35' },
        { codigo: 1040, descricao: '10:40' },
        { codigo: 1045, descricao: '10:45' },
        { codigo: 1050, descricao: '10:50' },
        { codigo: 1055, descricao: '10:55' },

        { codigo: 1100, descricao: '11:00' },
        { codigo: 1105, descricao: '11:05' },
        { codigo: 1110, descricao: '11:10' },
        { codigo: 1115, descricao: '11:15' },
        { codigo: 1120, descricao: '11:20' },
        { codigo: 1125, descricao: '11:25' },
        { codigo: 1130, descricao: '11:30' },
        { codigo: 1135, descricao: '11:35' },
        { codigo: 1140, descricao: '11:40' },
        { codigo: 1145, descricao: '11:45' },
        { codigo: 1150, descricao: '11:50' },
        { codigo: 1155, descricao: '11:55' },

        { codigo: 1200, descricao: '12:00' },
        { codigo: 1205, descricao: '12:05' },
        { codigo: 1210, descricao: '12:10' },
        { codigo: 1215, descricao: '12:15' },
        { codigo: 1220, descricao: '12:20' },
        { codigo: 1225, descricao: '12:25' },
        { codigo: 1230, descricao: '12:30' },
        { codigo: 1235, descricao: '12:35' },
        { codigo: 1240, descricao: '12:40' },
        { codigo: 1245, descricao: '12:45' },
        { codigo: 1250, descricao: '12:50' },
        { codigo: 1255, descricao: '12:55' },

        { codigo: 1300, descricao: '13:00' },
        { codigo: 1305, descricao: '13:05' },
        { codigo: 1310, descricao: '13:10' },
        { codigo: 1315, descricao: '13:15' },
        { codigo: 1320, descricao: '13:20' },
        { codigo: 1325, descricao: '13:25' },
        { codigo: 1330, descricao: '13:30' },
        { codigo: 1335, descricao: '13:35' },
        { codigo: 1340, descricao: '13:40' },
        { codigo: 1345, descricao: '13:45' },
        { codigo: 1350, descricao: '13:50' },
        { codigo: 1355, descricao: '13:55' },

        { codigo: 1400, descricao: '14:00' },
        { codigo: 1405, descricao: '14:05' },
        { codigo: 1410, descricao: '14:10' },
        { codigo: 1415, descricao: '14:15' },
        { codigo: 1420, descricao: '14:20' },
        { codigo: 1425, descricao: '14:25' },
        { codigo: 1430, descricao: '14:30' },
        { codigo: 1435, descricao: '14:35' },
        { codigo: 1440, descricao: '14:40' },
        { codigo: 1445, descricao: '14:45' },
        { codigo: 1450, descricao: '14:50' },
        { codigo: 1455, descricao: '14:55' },

        { codigo: 1500, descricao: '15:00' },
        { codigo: 1505, descricao: '15:05' },
        { codigo: 1510, descricao: '15:10' },
        { codigo: 1515, descricao: '15:15' },
        { codigo: 1520, descricao: '15:20' },
        { codigo: 1525, descricao: '15:25' },
        { codigo: 1530, descricao: '15:30' },
        { codigo: 1535, descricao: '15:35' },
        { codigo: 1540, descricao: '15:40' },
        { codigo: 1545, descricao: '15:45' },
        { codigo: 1550, descricao: '15:50' },
        { codigo: 1555, descricao: '15:55' },

        { codigo: 1600, descricao: '16:00' },
        { codigo: 1605, descricao: '16:05' },
        { codigo: 1610, descricao: '16:10' },
        { codigo: 1615, descricao: '16:15' },
        { codigo: 1620, descricao: '16:20' },
        { codigo: 1625, descricao: '16:25' },
        { codigo: 1630, descricao: '16:30' },
        { codigo: 1635, descricao: '16:35' },
        { codigo: 1640, descricao: '16:40' },
        { codigo: 1645, descricao: '16:45' },
        { codigo: 1650, descricao: '16:50' },
        { codigo: 1655, descricao: '16:55' },

        { codigo: 1700, descricao: '17:00' },
        { codigo: 1705, descricao: '17:05' },
        { codigo: 1710, descricao: '17:10' },
        { codigo: 1715, descricao: '17:15' },
        { codigo: 1720, descricao: '17:20' },
        { codigo: 1725, descricao: '17:25' },
        { codigo: 1730, descricao: '17:30' },
        { codigo: 1735, descricao: '17:35' },
        { codigo: 1740, descricao: '17:40' },
        { codigo: 1745, descricao: '17:45' },
        { codigo: 1750, descricao: '17:50' },
        { codigo: 1755, descricao: '17:55' },

        { codigo: 1800, descricao: '18:00' },
        { codigo: 1805, descricao: '18:05' },
        { codigo: 1810, descricao: '18:10' },
        { codigo: 1815, descricao: '18:15' },
        { codigo: 1820, descricao: '18:20' },
        { codigo: 1825, descricao: '18:25' },
        { codigo: 1830, descricao: '18:30' },
        { codigo: 1835, descricao: '18:35' },
        { codigo: 1840, descricao: '18:40' },
        { codigo: 1845, descricao: '18:45' },
        { codigo: 1850, descricao: '18:50' },
        { codigo: 1855, descricao: '18:55' },

        { codigo: 1900, descricao: '19:00' },
        { codigo: 1905, descricao: '19:05' },
        { codigo: 1910, descricao: '19:10' },
        { codigo: 1915, descricao: '19:15' },
        { codigo: 1920, descricao: '19:20' },
        { codigo: 1925, descricao: '19:25' },
        { codigo: 1930, descricao: '19:30' },
        { codigo: 1935, descricao: '19:35' },
        { codigo: 1940, descricao: '19:40' },
        { codigo: 1945, descricao: '19:45' },
        { codigo: 1950, descricao: '19:50' },
        { codigo: 1955, descricao: '19:55' },

        { codigo: 2000, descricao: '20:00' },
        { codigo: 2005, descricao: '20:05' },
        { codigo: 2010, descricao: '20:10' },
        { codigo: 2015, descricao: '20:15' },
        { codigo: 2020, descricao: '20:20' },
        { codigo: 2025, descricao: '20:25' },
        { codigo: 2030, descricao: '20:30' },
        { codigo: 2035, descricao: '20:35' },
        { codigo: 2040, descricao: '20:40' },
        { codigo: 2045, descricao: '20:45' },
        { codigo: 2050, descricao: '20:50' },
        { codigo: 2055, descricao: '20:55' },

        { codigo: 2100, descricao: '21:00' },
        { codigo: 2105, descricao: '21:05' },
        { codigo: 2110, descricao: '21:10' },
        { codigo: 2115, descricao: '21:15' },
        { codigo: 2120, descricao: '21:20' },
        { codigo: 2125, descricao: '21:25' },
        { codigo: 2130, descricao: '21:30' },
        { codigo: 2135, descricao: '21:35' },
        { codigo: 2140, descricao: '21:40' },
        { codigo: 2145, descricao: '21:45' },
        { codigo: 2150, descricao: '21:50' },
        { codigo: 2155, descricao: '21:55' },
    ];

    public static listaTipoAgendamento: ChaveValorStrInterface[] = [
        { codigo: 'HM', descricao: 'Hora Marcada' },
        { codigo: 'OC', descricao: 'Ordem de Chegada' },
    ];

    public static listaEventosSistema: ChaveValorStrInterface[] = [
        { codigo: 'INS', descricao: 'INSERÇÃO' },
        { codigo: 'ATU', descricao: 'ATUALIZAÇÃO' },
        { codigo: 'EXC', descricao: 'EXCLUSÃO' },
    ];

    public static listaMenusSistema: ChaveValorStrInterface[] = [
        { codigo: 'PRC', descricao: 'PROCEDIMENTO' },
        { codigo: 'PCC', descricao: 'CONSULTA' },
        { codigo: 'PSA', descricao: 'PLANO DE SAÚDE' },
        { codigo: 'MEP', descricao: 'MARC. EXAME PACIENTE' },
        { codigo: 'MCP', descricao: 'MARC. CONSULTA PACIENTE' },
        { codigo: 'USR', descricao: 'CADASTRO DE USUÁRIO' },
        { codigo: 'CNF', descricao: 'CONFIGURAÇÃO' },
        { codigo: 'AME', descricao: 'AGENDA MÉDICA' },
        { codigo: 'APR', descricao: 'AGENDA PROCEDIMENTO' },
    ];

    public static listaTipoAgrupamentoDisponibilidadeDeVagasParaConsulta: ChaveValorStrInterface[] = [
        { codigo: '0', descricao: 'Não Agrupar' },
        { codigo: '1', descricao: 'Data Marcação' },
        { codigo: '2', descricao: 'Consulta' },
    ];

    public static listaTipoAgrupamentoDisponibilidadeDeVagasParaProcedimentos: ChaveValorStrInterface[] = [
        { codigo: '0', descricao: 'Não Agrupar' },
        { codigo: '1', descricao: 'Data Marcação' },
        { codigo: '2', descricao: 'Procedimento' },
    ];

    public static listaTipoAgrupamentoParaMarcacaoInterna: ChaveValorStrInterface[] = [
        { codigo: '0', descricao: 'Não Agrupar' },
        { codigo: '1', descricao: 'Data Criação' },
        { codigo: '2', descricao: 'Funcionário' },
    ];

    public static listaDiasDaSemana: ChaveValorNumberInterface[] = [
        { codigo: 1, descricao: 'Segunda' },
        { codigo: 2, descricao: 'Terça' },
        { codigo: 3, descricao: 'Quarta' },
        { codigo: 4, descricao: 'Quinta' },
        { codigo: 5, descricao: 'Sexta' },
        { codigo: 6, descricao: 'Sábado' },
        { codigo: 7, descricao: 'Domingo' },
    ];

    public static listaStatusEnvioComprovante: ChaveValorBooleanInterface[] = [
        { codigo: true, descricao: 'Sucesso' },
        { codigo: false, descricao: 'Falha' },
    ];


    public static listaDiasAgenda: ChaveValorNumberInterface[] = [
        { codigo: 5, descricao: '5' },
        { codigo: 10, descricao: '10' },
        { codigo: 15, descricao: '15' },
        { codigo: 20, descricao: '20' },
        { codigo: 25, descricao: '25' },
        { codigo: 30, descricao: '30' },
        { codigo: 35, descricao: '35' },
        { codigo: 40, descricao: '40' },
        { codigo: 45, descricao: '45' },
        { codigo: 50, descricao: '50' },
        { codigo: 55, descricao: '55' },
        { codigo: 60, descricao: '60' },
        { codigo: 65, descricao: '65' },
        { codigo: 70, descricao: '70' },
        { codigo: 75, descricao: '75' },
        { codigo: 80, descricao: '80' },
        { codigo: 85, descricao: '85' },
        { codigo: 90, descricao: '90' },
        { codigo: 95, descricao: '95' },
        { codigo: 100, descricao: '100' },
    ];



    public static dataInvalida = (c: FormControl) => {
        const DATE_REGEXP = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;

        let teste: boolean = DATE_REGEXP.test(c.value);

        if (teste) {
            let dataAtual: Date = new Date();
            dataAtual.setHours(0);
            dataAtual.setMinutes(0);
            dataAtual.setSeconds(0);
            dataAtual.setMilliseconds(0);

            //String to Date
            let dateDiaMesAnoArray = c.value.split('-');
            let ano = Number(dateDiaMesAnoArray[0]);
            let mes = Number(dateDiaMesAnoArray[1]) - 1;
            let dia = Number(dateDiaMesAnoArray[2]);

            let dataTeste: Date = new Date(ano, mes, dia);
            dataTeste.setHours(0);
            dataTeste.setMinutes(0);
            dataTeste.setSeconds(0);
            dataTeste.setMilliseconds(0);

            // console.log(dataAtual.getTime() + " - " + dataTeste.getTime());

            if (dataTeste.getTime() >= dataAtual.getTime()) {
                teste = false;
            }
        }

        return teste || c.value === '' ? null : {
            dataValidada: {
                valid: false
            }
        };
    }

    public static dataInvalidaSemConsiderarDataMaiorQueAtual = (c: FormControl) => {
        const DATE_REGEXP = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;

        let teste: boolean = DATE_REGEXP.test(c.value);

        return teste || c.value === '' ? null : {
            dataValidada: {
                valid: false
            }
        };
    }

    public static validaCpf(cpf: string): boolean {

        if (cpf == null) {
            return false;
        }

        if (cpf.length != 11) {
            return false;
        }

        if ((cpf == '00000000000') || (cpf == '11111111111') ||
            (cpf == '22222222222') || (cpf == '33333333333') ||
            (cpf == '44444444444') || (cpf == '55555555555') ||
            (cpf == '66666666666') || (cpf == '77777777777') ||
            (cpf == '88888888888') || (cpf == '99999999999')) {

            return false;
        }

        let numero: number = 0;
        let caracter: string = '';
        let numeros: string = '0123456789';
        let j: number = 10;
        let somatorio: number = 0;
        let resto: number = 0;
        let digito1: number = 0;
        let digito2: number = 0;
        let cpfAux: string = '';

        cpfAux = cpf.substring(0, 9);

        for (let i: number = 0; i < 9; i++) {
            caracter = cpfAux.charAt(i);
            if (numeros.search(caracter) == -1) {
                return false;
            }
            numero = Number(caracter);
            somatorio = somatorio + (numero * j);
            j--;
        }

        resto = somatorio % 11;
        digito1 = 11 - resto;
        if (digito1 > 9) {
            digito1 = 0;
        }

        j = 11;
        somatorio = 0;
        cpfAux = cpfAux + digito1;
        for (let i: number = 0; i < 10; i++) {
            caracter = cpfAux.charAt(i);
            numero = Number(caracter);
            somatorio = somatorio + (numero * j);
            j--;
        }

        resto = somatorio % 11;
        digito2 = 11 - resto;
        if (digito2 > 9) {
            digito2 = 0;
        }

        cpfAux = cpfAux + digito2;
        if (cpf != cpfAux) {
            return false;
        } else {
            return true;
        }
    }

    public static getHoraFormatada(hora: string): string {
        if (hora) {
            if (hora.length == 4) {
                hora = hora.substring(0, 2) + ":" + hora.substring(2, 4);
            } else if (hora.length == 3) {
                hora = "0" + hora.substring(0, 1) + ":" + hora.substring(1, 3);
            } else if (hora.length == 2) {
                hora = "00:" + hora.substring(0, 2);
            } else if (hora.length == 1) {
                hora = "00:0" + hora.substring(0, 1);
            }
        } else {
            return "";
        }

        return hora;
    }

    public static pattern = {
        9: {
            pattern: new RegExp('\\d'),
        },
    };
    public static mascaraFoneCustom(fone: string): [string, any] {
        if (fone) {
            if (fone.length <= 10) {
                return ['(99) 9999-9999', this.pattern];
            } else {
                return ['(99) 9 9999-9999', this.pattern];
            }
        }
        return ['(99) 9 9999-9999', this.pattern];
    }

    public static getIconeTipoStatusNotificacao(tipoStatusNotificacao: TipoStatusNotificacaoEnum | null): string {

        const currentTipoStatusNotificacao = TipoStatusNotificacaoEnum.getFromCode(tipoStatusNotificacao as string);

        let icone: string = '';

        if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.SUC) {
            icone = 'check_circle';
        } else if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.WRN) {
            icone = 'error';
        } else if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.ERR) {
            icone = 'cancel';
        } else {
            icone = 'help_outline';
        }

        return icone;
    }

    public static getCorTipoStatusNotificacao(tipoStatusNotificacao: TipoStatusNotificacaoEnum | null): string {

        const currentTipoStatusNotificacao = TipoStatusNotificacaoEnum.getFromCode(tipoStatusNotificacao as string);

        let cor: string = '';

        if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.SUC) {
            cor = 'success';
        } else if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.WRN) {
            cor = 'warning';
        } else if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.ERR) {
            cor = 'warn';
        }

        return cor;
    }

    public static getTooltipTipoStatusNotificacao(tipoStatusNotificacao: TipoStatusNotificacaoEnum | null): string {

        const currentTipoStatusNotificacao = TipoStatusNotificacaoEnum.getFromCode(tipoStatusNotificacao as string);

        let tooltip: string = '?';

        if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.SUC) {
            tooltip = 'Sucesso';
        } else if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.WRN) {
            tooltip = 'Alguns Erros';
        } else if (currentTipoStatusNotificacao === TipoStatusNotificacaoEnum.ERR) {
            tooltip = 'Erro';
        } else {
            tooltip = 'Não Reconhecido';
        }

        return tooltip;
    }

    public static getIconeStatusMarcacao(status: string | undefined): string {


        let icone: string = '';

        if (status) {
            if (status === MarcacaoConsulta.STATUS_AGENDADO) {
                icone = 'schedule';
            } else if (status === MarcacaoConsulta.STATUS_FINALIZADO) {
                icone = 'check_circle';
            } else if (status === MarcacaoConsulta.STATUS_CANCELADO) {
                icone = 'cancel';
            } else {
                icone = 'help_outline';
            }
        }

        return icone;
    }

    public static getCorStatusMarcacao(status: string | undefined): string {


        let cor: string = '';

        if (status) {
            if (status === MarcacaoConsulta.STATUS_AGENDADO) {
                cor = 'warning';
            } else if (status === MarcacaoConsulta.STATUS_FINALIZADO) {
                cor = 'success';
            } else if (status === MarcacaoConsulta.STATUS_CANCELADO) {
                cor = 'warn';
            }
        }

        return cor;
    }

    public static getTooltipStatusMarcacao(status: string | undefined): string {

        let tooltip: string = '?';

        if (status) {
            if (status === MarcacaoConsulta.STATUS_AGENDADO) {
                tooltip = 'Espera';
            } else if (status === MarcacaoConsulta.STATUS_FINALIZADO) {
                tooltip = 'Concluída';
            } else if (status === MarcacaoConsulta.STATUS_CANCELADO) {
                tooltip = 'Cancelada';
            } else {
                tooltip = 'Não Reconhecido';
            }
        }

        return tooltip;
    }

    public static getIconeCobrarAtendimento(cobrar: boolean | undefined): string {
        let icone: string = '';

        if (cobrar && cobrar === true) {
            icone = 'paid';
        }

        return icone;
    }

    public static getCorCobrarAtendimento(cobrar: boolean | undefined): string {
        let cor: string = '';

        if (cobrar && cobrar === true) {
            cor = 'success';
        }

        return cor;
    }

    public static getTooltipCobrarAtendimento(cobrar: boolean | undefined): string {
        let tooltip: string = '';

        if (cobrar && cobrar === true) {
            tooltip = 'Cobrar este Atendimento!';
        }

        return tooltip;
    }

    public static getIconePNE(pne: boolean | undefined): string {
        let icone: string = '';

        if (pne && pne === true) {
            icone = 'accessible';
        }

        return icone;
    }

    public static getCorPNE(pne: boolean | undefined): string {
        let cor: string = '';

        if (pne && pne === true) {
            cor = '';
        }

        return cor;
    }

    public static getTooltipPNE(pne: boolean | undefined): string {
        let tooltip: string = '';

        if (pne && pne === true) {
            tooltip = 'PNE';
        }

        return tooltip;
    }

    public static getIconePeriodoVolta(periodoVolta: boolean | undefined): string {
        let icone: string = '';

        if (periodoVolta && periodoVolta === true) {
            icone = 'reply';
        }

        return icone;
    }

    public static getCorPeriodoVolta(periodoVolta: boolean | undefined): string {
        let cor: string = '';

        if (periodoVolta && periodoVolta === true) {
            cor = '';
        }

        return cor;
    }

    public static getTooltipPeriodoVolta(periodoVolta: boolean | undefined): string {
        let tooltip: string = '';

        if (periodoVolta && periodoVolta === true) {
            tooltip = 'Período de Volta';
        }

        return tooltip;
    }
}
